// extracted by mini-css-extract-plugin
export default {"messages":"Messages_messages__dRX4C","message":"Messages_message__cISlo","text":"Messages_text__cVPeT","user":"Messages_user__TeFrw","me":"Messages_me__vguDV"};